import React from 'react';

import { Heading } from '@klp/design/Heading';
import { Main } from '@klp/layout';
import { Block } from '@klp/design/Block';

import { ContractManagementAppBar } from '../components/ContractManagementAppBar';
import { ContractManagementContent } from '../components/ContractManagementContent';
import ChatView from '../components/ChatView';
import i18n from '@forvalter/i18n/config';

export const ContractManagementView: React.FC = () => (
    <Main>
        <Main.Breadcrumbs>
            <Main.Crumb
                id="contractmanagement"
                label={i18n.t('breadcrumbs.contractManagement')}
            />
        </Main.Breadcrumbs>
        <Block>
            <Heading
                klpHeadingLevel="TWO"
                translation="contractManagement.title"
                data-cy="ContractRegistrationView__Title"
            />
        </Block>
        <ContractManagementAppBar />
        <ContractManagementContent />
        <ChatView />
    </Main>
);
